import { fetchData } from '../utils.js'
import { useEffect, useState } from 'react'
import Loader from './Loader.jsx'



const Kontakt = () => {
    const [content, setContent] = useState({})
    const [loader, setLoader] = useState(true)

    useEffect (() => {
        fetchData('pageContent/kontakt', 'GET', null, (data) => {
            setContent(data)
            setLoader(false)
        })
    }, [])

    if (loader) return <Loader/>

    return (
        <div className="w-100p padd-7p bg-my padd-b-5p">
            <div className="">
                <table className="contact-table">
                    <thead className="head-of-table">
                        <tr>
                            <th colSpan="2">
                                {content.head_kontakt}
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-centre">
                        <tr>
                            <td>
                                Nazwa firmy
                            </td>
                            <td>
                                {content.company_name}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Adres
                            </td>
                            <td>
                                {content.adres}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Telefon
                            </td>
                            <td>
                                <a className="text-black" href={`tel:${content.telefon}`}>
                                    {content.telefon}
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                E-mail
                            </td>
                            <td>
                                <a className="text-black" href={`mailto:${content.email}`}>
                                    {content.email}
                                </a>         
                            </td>
                        </tr>
                        <tr>
                            <td>
                                NIP
                            </td>
                            <td>
                                {content.nip}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Numer rachunku	
                            </td>
                            <td>
                                {content.account_number}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Czas pracy
                            </td>
                            <td>
                                {content.working_time}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Kontakt